// tslint:disable: completed-docs
/**
 * Own area for container
 */
import {SAILS_APP_NAME} from 'Constant';
export const TRACKING_STORE = 'TRACKING';

/**
 * Tracking: we only need success action for tracking apply_filter
 * and accordion_opened, as the offerId will be saved in store in
 * this case. no need for a success action in the two other cases.
 */
export const TRACK_PAGE_VIEW = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_PAGE_VIEW`;

export const TRACK_APPLY_FILTER = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_APPLY_FILTER`;
export const TRACK_APPLY_FILTER_SUCCESS = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_APPLY_FILTER_SUCCESS`;

export const TRACK_ACCORDION_OPEN = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_ACCORDION_OPEN`;
export const TRACK_ACCORDION_OPEN_SUCCESS = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_ACCORDION_OPEN_SUCCESS`;

export const TRACK_HOTLINE_CTA_CLICK = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_HOTLINE_CTA_CLICK`;

export const TRACK_FAQ_ACCORDION_OPEN = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_FAQ_ACCORDION_OPEN`;

export const TRACK_ERROR_JSON_NOT_FOUND = `${SAILS_APP_NAME}/${TRACKING_STORE}/TRACK_ERROR_JSON_NOT_FOUND`;

export const TRACKING_ERROR_NOT_FOUND_MESSAGE = 'JSON file not found';

export const TRACKING_ERROR_NOT_FOUND_TYPE = 'technical';

// Tracking

// Page-View
export const TRACKING_LOGGED_IN = 'logged in';
export const TRACKING_NOT_LOGGED_IN = 'not logged in';
export const TRACKING_PAGE_TYPE = 'product listing';
export const TRACKING_SITE_AREA = 'mobility';
export const TRACKING_PLATFORM_TYPE = 'responsive';

// Apply-Filter
export const TRACKING_ADD_FILTER_ACTION = 'add filter';

// Accordeon open
export const TRACKING_ACCORDEON_INTERACTION_TYPE = 'accordeon click';
export const TRACKING_ACCORDEON_ELEMENT_NAME = 'price details';
